import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 30px 0px 0px;\n  height: 148px;\n  width: 100%;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { compose } from 'recompose';
import styled, { withTheme } from '../utils/styling/styled-components';
import { RoundActionButton } from '../ActionButton';
import { theme } from '../theme';
var Actions = styled.div(_templateObject(), theme.colors.white);
var enhance = compose(withTheme);
var MobileActions = enhance(function (props) {
  return /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, /*#__PURE__*/React.createElement(Actions, {
    className: props.className
  }, props.actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(RoundActionButton, {
      key: index,
      text: action.text,
      icon: action.icon,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      className: action.className
    });
  })));
});
export { MobileActions };